import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import BackUpButton from "./ActionsButton/BackUpButton";
import UpdateInventoryButton from "./ActionsButton/UpdateInventoryButton";
import DeleteButton from "./ActionsButton/DeleteButton";
import { AdminSwitch } from "../../../../SharedComponents/ListView";
import { UpdateIsArchive, UpdateIsVitrine, GetInventories } from "../../Store/Thunk";
import { applicationTypeEnum } from "../../../../../../Helpers/EnumHelper";

// Mutation controls (showcase / archive switches + backup + edit + delete) for an
// inventory row, rendered as a fragment so the parent groups them in one cluster.
const RowButtons = React.memo(({ inventory }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <>
      <AdminSwitch
        label={t("vitrine")}
        checked={inventory.isVitrine}
        onChange={(e) =>
          dispatch(
            UpdateIsVitrine({
              payload: {
                applicationType: applicationTypeEnum.Inventory,
                id: inventory.id,
                isVitrine: e.target.checked,
              },
              callback: GetInventories,
            })
          )
        }
      />
      <AdminSwitch
        label={t("archive")}
        checked={inventory.isArchive}
        onChange={(e) =>
          dispatch(
            UpdateIsArchive({
              payload: {
                applicationType: applicationTypeEnum.Inventory,
                id: inventory.id,
                isArchive: e.target.checked,
              },
              callback: GetInventories,
            })
          )
        }
      />
      <BackUpButton inventory={inventory} />
      <UpdateInventoryButton application={inventory} />
      <DeleteButton inventory={inventory} />
    </>
  );
});

export default RowButtons;
